import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

import {
  Drawer,
  Button,
  Form,
  Divider,
  Space
} from '@lockerpm/design';

import {
  useStripe,
  useElements,
  CardNumberElement
} from '@stripe/react-stripe-js';

import paymentFormComponents from '../payment-form';

import global from '../../config/global';
import paymentServices from '../../services/payment';

function CreditCardForm(props) {
  const {
    PaymentMethods,
    BillingContact,
    BillingAddress
  } = paymentFormComponents;

  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();

  const {
    visible = false,
    card = null,
    onClose = () => {},
    onReload = () => {},
  } = props

  
  const [form] = Form.useForm();
  const [callingAPI, setCallingAPI] = useState(false);

  useEffect(() => {
    if (visible) {
      if (!card) {
        form.setFieldsValue({
          address: '',
          address_country: '',
          address_city: '',
          address_state: '',
          address_zip: ''
        })
      } else {
        form.setFieldsValue({
          address: card.address,
          address_country: card.address_country,
          address_city: card.address_city,
          address_state: card.address_state,
          address_zip: card.address_zip
        })
      }
    }
  }, [visible, card])

  const handleCreate = async (values) => {
    const cardNumberElement = elements.getElement(CardNumberElement);
    const tokenData = {
      name: values.name,
      address_line1: values.address,
      address_line2: values.address_country,
      address_country: values.address_country,
      country: values.address_country,
      address_city: values.address_city,
      address_state: values.address_state || '',
      address_zip: values.address_zip || '',
      currency: 'USD'
    }
    await stripe.createToken(cardNumberElement, tokenData).then(async (response) => {
      if (response.error) {
        switch (response.error?.type) {
          case 'validation_error':
            global.pushError({ message: t('notification.error.payment.validation_error') });
            break
          default:
            global.pushError({ message: t('notification.error.payment.generic_decline') });
        }
      } else {
        await paymentServices.add_payments_card({
          token_card: response.token.id,
          metadata: {
            email: values.contact_email,
            contact_name: values.contact_name,
            company: values.contact_company
          }
        }).then(() => {
          global.pushSuccess(t('notification.success.payments.updated_card'));
          onReload();
          onClose();
        }).catch((error) => {
          global.pushError(error)
        })
      }
    })
  };

  const handleUpdate = async (values) => {
    await paymentServices.update_payments_card(card.id_card, {
      ...values,
      country: values.address_country,
    }).then(() => {
      global.pushSuccess(t('notification.success.payments.updated_card'));
      onReload();
      onClose();
    }).catch((error) => {
      global.pushError(error);
    })
  }

  const handleSave = async () => {
    form.validateFields().then(async (values) => {
      setCallingAPI(true);
      if (card) {
        await handleUpdate(values)
      } else {
        await handleCreate(values);
      }
      setCallingAPI(false);
    })
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('plans_billing.payment_methods.form_title')}
        placement="right"
        width={500}
        onClose={onClose}
        open={visible}
        footer={
          <Space className='flex items-center justify-end'>
            <Button disabled={callingAPI} onClick={onClose}>
              {t("button.cancel")}
            </Button>
            <Button type='primary' loading={callingAPI} onClick={handleSave}>
              {t("button.save")}
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
        >
          {
            !card && <>
              <PaymentMethods/>
              <Divider />
              <BillingContact/>
              <Divider />
            </>
          }
          <BillingAddress/>
        </Form>
      </Drawer>
    </div>
  );
}

export default CreditCardForm;
